import React, { Component } from 'react';
import {
    Container, Row, Col, Form, FormGroup, Input, Label, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';
import { armarDia, ordenarDias } from '../../../utilitarios/horarios';
import { Icon } from 'react-icons-kit';
import { trash } from 'react-icons-kit/fa/trash'
import './horarios.css';


export default class AdminHorarios extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dia: {
                Indice: 0,
                Dia: 'Lunes',
                MatDesde: '08:30',
                MatHasta: '12:00',
                VesDesde: '15:00',
                VesHasta: '20:00'
            }
        }
        this.onChange = this.onChange.bind(this)
        this.onChangeDia = this.onChangeDia.bind(this)
        this.guardarHorario = this.guardarHorario.bind(this)
        this.editarDia = this.editarDia.bind(this)
    }

    onChange(e) {
        this.setState({
            dia: {
                ...this.state.dia,
                [e.target.id]: e.target.value
            }
        })
    }

    onChangeDia(e) {
        this.setState({
            dia: {
                ...this.state.dia,
                Indice: e.target.value,
                Dia: e.target.options[e.target.selectedIndex].text
            }
        })
    }

    editarDia(e){
        e.preventDefault()
        // this.props.horarios.forEach(dia => {
        //     if(dia.Dia == e.target.id){
        //         this.setState({
        //             dia
        //         })
        //     }
        // })
    }

    guardarHorario(e) {
        e.preventDefault()
        //console.log(this.state.dia)
        this.props.guardarHorario(this.state.dia)
    }

    componentDidMount() {

    }

    render() {
        return (
            <Container>
                <Row>
                    <FormGroup>
                        <Label for="Dia">Día</Label>
                        <Input type="select" id="Dia" bsSize="sm" onChange={this.onChangeDia} value={this.state.dia.Indice}>
                            <option value={0}>Lunes</option>
                            <option value={1}>Martes</option>
                            <option value={2}>Miércoles</option>
                            <option value={3}>Jueves</option>
                            <option value={4}>Viernes</option>
                            <option value={5}>Sábado</option>
                            <option value={6}>Domingo</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="MatDesde">Desde</Label>
                        <Input
                            type="time"
                            id="MatDesde"
                            placeholder="time placeholder"
                            bsSize="sm"
                            onChange={this.onChange}
                            value={this.state.dia.MatDesde}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="MatHasta">Hasta</Label>
                        <Input
                            type="time"
                            id="MatHasta"
                            placeholder="time placeholder"
                            bsSize="sm"
                            onChange={this.onChange}
                            value={this.state.dia.MatHasta}
                        />
                    </FormGroup>
                    {' '}
                    <FormGroup>
                        <Label for="VesDesde">Desde</Label>
                        <Input
                            type="time"
                            id="VesDesde"
                            placeholder="time placeholder"
                            bsSize="sm"
                            onChange={this.onChange}
                            value={this.state.dia.VesDesde}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="VesHasta">Hasta</Label>
                        <Input
                            type="time"
                            id="VesHasta"
                            placeholder="time placeholder"
                            bsSize="sm"
                            onChange={this.onChange}
                            value={this.state.dia.VesHasta}
                        />
                    </FormGroup>
                    <Button size="sm" onClick={this.guardarHorario}>Aplicar horario</Button>
                </Row>
                <Row>
                    <Col xs={12} >
                        <ListGroup className="listaHorarios">
                            <ListGroupItem active tag="button" color="dark" action>Horario de atención:</ListGroupItem>
                            {
                                ordenarDias(this.props.horarios).map((dia) => {
                                    return (
                                        <ListGroupItem id={dia.Dia} key={dia.Dia} tag="button" onClick={this.editarDia} action>
                                            {
                                                armarDia(dia)
                                            }
                                        </ListGroupItem>
                                    )
                                })
                            }
                        </ListGroup>
                    </Col>
                </Row>
            </Container>
        )
    }

}
